import { TFunction } from 'react-i18next';

export const adaptBenchmarks = (data: any, t: TFunction<'translation', undefined>) => {
    const option = { label: t('clientDashboard.portfolio.selectOption'), value: '', disabled: true };

    if (data.TotalCount === 0) return [option];

    return (data.Results || []).map(({ Id, Name }) => ({
        label: Name,
        value: Id,
    }));
};
